import { render, staticRenderFns } from "./navlist.vue?vue&type=template&id=b08696b6&"
import script from "./navlist.vue?vue&type=script&lang=js&"
export * from "./navlist.vue?vue&type=script&lang=js&"
import style0 from "./navlist.vue?vue&type=style&index=0&id=b08696b6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports